import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { DataSelectBox } from '../../models/selectbox';
import { layDsQuocTich} from '../../services/danhmuc';
 
const QuocTichSelectBox = ({value, disabled, onChange }: {value? : number, disabled?: boolean, onChange: (e: any) => void }) => {

    const [data, setData] = useState<Array<DataSelectBox>>([]);
    const layDuLieu = async () => {
        try {
            let rs = await layDsQuocTich(); 
            setData(rs);
        } catch (error: any) {
        };
    }
    useEffect(() => {
        layDuLieu();
    }, []);
    return (
        <Select
            style={{ width: '100%' }}
            showSearch
            placeholder="--Chọn quốc tịch--"
            filterOption={function (search, item: any) {
                return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
            }}
            options={data}
            value={value}
            onChange={(e: number) => {
                onChange({
                    target: {
                        name: name,
                        value: e
                    }
                })
            }}
            disabled={disabled}
        />
    );
};

export default QuocTichSelectBox;
